import {
  DeleteSystemOperationMenuRequest,
  DeleteSystemOperationMenuRequestToJSON,
  HTTPBody,
  RegisterSystemOperationMenuRequest,
  RegisterSystemOperationMenuRequestToJSON,
  SystemOperationMenu,
  SystemOperationMenuFromJSON,
  UpdateSystemOperationMenuRequest,
  UpdateSystemOperationMenuRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class SystemOperationMenuApi extends runtime.BaseAPI {
  /**
   * 運用メニュー一覧取得
   * 運用メニュー一覧を取得する
   */
  async getSystemOperationMenus(): Promise<SystemOperationMenu[]> {
    const response = await this.requestGet(`/system-operation-menus`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemOperationMenuFromJSON)
    ).value()
  }

  /**
   * 運用メニューを取得する
   * 運用メニュー取得
   */
  async getSystemOperationMenu(id: string): Promise<SystemOperationMenu> {
    const response = await this.requestGet(`/system-operation-menus/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      SystemOperationMenuFromJSON(jsonValue)
    ).value()
  }

  /**
   * 運用メニューを登録する
   * 運用メニュー登録
   */
  async registerSystemOperationMenu(
    request: RegisterSystemOperationMenuRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterSystemOperationMenuRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/system-operation-menus',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 運用メニューを更新する
   * 運用メニュー更新
   */
  async updateSystemOperationMenu(
    request: UpdateSystemOperationMenuRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateSystemOperationMenuRequestToJSON(
      request
    )

    const response = await this.requestPut(
      `/system-operation-menus/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 運用メニューを削除する
   * 運用メニュー削除
   */
  async deleteSystemOperationMenu(
    request: DeleteSystemOperationMenuRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteSystemOperationMenuRequestToJSON(
      request
    )

    const response = await this.requestDelete(
      `/system-operation-menus/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
